import { saveLog } from "@/modules/logger";

export default {
  mounted() {
    saveLog("open");
  },
};
